import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import FlowExplorer from '@/components/feature/FlowExplorer';
import { supplyFlow } from '@/mocks/jiuchou-business';

export default function SupplyChain() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="供应链"
            title="让农产品从「产品」变成「数字商品」"
            subtitle="从产地到数字货架、云店、消费者，再到需求反馈与生产优化，形成农产品数字化上行的完整链路。"
          />
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-12">
            <FlowExplorer steps={supplyFlow} direction="horizontal" accent="primary" />
          </div>
        </Reveal>

        <Reveal delay={150}>
          <p className="mt-8 text-sm text-foreground-500 leading-relaxed text-center max-w-3xl mx-auto">
            这直接对应国家数字乡村工作中持续推进的「数商兴农」、农产品出村进城、农村电商供应链和农产品质量安全追溯等方向。
          </p>
        </Reveal>
      </div>
    </section>
  );
}